import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ArrayHelper } from '../../../../helpers/arrayHelper';
import { ComponentBase } from '../../../../helpers/ComponentBase';
import { IDatabaseSyncStatus } from '../../model/IDatabaseSyncStatus';
import { DatabaseSynchroService } from '../../services/database-synchro.service';

@Component({
	selector: 'calao-databases-sync-status-list',
	templateUrl: './databases-sync-status-list.component.html',
	styleUrls: ['./databases-sync-status-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatabasesSyncStatusListComponent extends ComponentBase {

	//#region PROPERTIES

	private maDatabasesSyncStatus: IDatabaseSyncStatus[];
	public get databasesSyncStatus(): IDatabaseSyncStatus[] { return this.maDatabasesSyncStatus; }
	@Input()
	public set databasesSyncStatus(paDatabasesSyncStatus: IDatabaseSyncStatus[]) {
		if (!this.isDatabasesSyncStatusEqual(paDatabasesSyncStatus)) {
			this.maDatabasesSyncStatus = paDatabasesSyncStatus;
			this.detectChanges();
		}
	}

	//#endregion

	//#region METHODS

	constructor(poChangeDetectorRef: ChangeDetectorRef) {
		super(poChangeDetectorRef);
	}

	private isDatabasesSyncStatusEqual(paDatabasesSyncStatus: IDatabaseSyncStatus[]): boolean {
		return ArrayHelper.areArraysEqual(
			paDatabasesSyncStatus,
			this.maDatabasesSyncStatus,
			(poItemA: IDatabaseSyncStatus, poItemB: IDatabaseSyncStatus) => DatabaseSynchroService.areDatabasesStatusEquals(poItemA, poItemB)
		);
	}

	//#endregion

}